<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && tool">
			<div class="col-sm-12">
				<div class="row">
					<!-- company -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.company' | translate }}*</label>
						<ng-template [ngIf]="companyid">
							<input
								name="companyinput"
								[placeholder]="selected.company?.name"
								required
								type="text"
								class="form-control"
								id="companyinput"
								disabled>
						</ng-template>
						<ng-template [ngIf]="!companyid">
							<app-entity-autocomplete
								entityName="company"
								entityField="name"
								entityFilterType="like"
								[entitySearch]="search.company"
								name="company"
								[(ngModel)]="selected.company"
								placeholder
								required
								#companyautocomp="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && companyautocomp.invalid"
								style="display: block;">
								{{'errors.required' | translate}}
							</div>

						</ng-template>
					</div>
					<!-- name -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.name' | translate }}*</label>
						<input
							[(ngModel)]="tool.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- value -->
					<div class="form-group col-md-4">
						<label>{{'labels.value' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="value"
							[(ngModel)]="tool.value"
							required
							#value="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && value.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && value.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- depreciationstart -->
					<div class="form-group col-md-4">
						<label>
							{{'labels.depreciationstart' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="tool.depreciationstart"
							name="depreciationstart"
							required
							#depreciationstart="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && depreciationstart.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && depreciationstart.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- depreciationend -->
					<div class="form-group col-md-4">
						<label>
							{{'labels.depreciationend' | translate}}*
						</label>
						<app-datepicker
							[(ngModel)]="tool.depreciationend"
							name="depreciationend"
							required
							#depreciationend="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && depreciationend.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && depreciationend.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- shortdesc -->
					<div class="form-group col-md-12">
						<label for="cname">{{ 'labels.shortdesc' | translate }}</label>
						<textarea
							[(ngModel)]="tool.shortdesc"
							#shortdesc="ngModel"
							name="shortdesc"
							type="text"
							class="form-control"
							placeholder="{{ 'labels.shortdesc' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && shortdesc.invalid}">
						</textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
